(function () {
  var thumbs = document.querySelectorAll('.nf-thumb');
  var hero = document.getElementById('nf-hero-img');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (hero && t.dataset.src) { hero.src = t.dataset.src; hero.srcset = ''; }
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var data = document.getElementById('nf-variants');
  if (!data) return;

  var variants = [];
  try { variants = JSON.parse(data.textContent || '[]'); } catch (e) { return; }

  var idField = document.getElementById('nf-variant-id');
  var priceEl = document.getElementById('nf-price');
  var totalEl = document.getElementById('nf-total');
  var qtyInput = document.getElementById('nf-qty');

  // Only real variant-option dropdowns carry data-option. Property dropdowns
  // (finish, ring colour, specs mode) must never take part in variant matching.
  var selects = Array.prototype.slice.call(document.querySelectorAll('select.nf-select[data-option]'))
    .sort(function (a, b) {
      return parseInt(a.getAttribute('data-option'), 10) - parseInt(b.getAttribute('data-option'), 10);
    });

  function money(cents) {
    var amount = cents / 100;
    var str = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + str;
  }

  function sync() {
    var chosen = selects.map(function (s) { return s.value; });
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (chosen[j] && v.options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }
    if (!match) return;

    if (idField) idField.value = match.id;
    if (priceEl) priceEl.textContent = money(match.price);

    var q = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (totalEl) totalEl.textContent = money(match.price * q);
  }

  selects.forEach(function (s) { s.addEventListener('change', sync); });

  document.querySelectorAll('.nf-qty__btn').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      var v = parseInt(qtyInput.value, 10) || 1;
      v = Math.min(20, Math.max(1, v + parseInt(b.dataset.step, 10)));
      qtyInput.value = v;
      sync();
    });
  });
  if (qtyInput) qtyInput.addEventListener('input', sync);

  sync();
})();
